var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isH5)?_c('PcHome'):_c('H5Home')
}
var staticRenderFns = []

export { render, staticRenderFns }